<ng-container *ngIf="!multiSelect; else multiSelectT">
  <div class="user-autocomplete-wrapper" style="position: relative;">
    <app-form-field
      [formGroup]="formGroup"
      [fieldControlName]="fieldControlName"
      [fieldLabel]="fieldLabel"
      [col]="col"
      type="autocomplete"
      [options]="userList"
      [localizeOptions]="false"
      [validatorOrOpts]="validatorOrOpts"
    ></app-form-field>
    <div class="autocomplete-loading fade-transition" [class.visible]="loading" aria-live="polite">
      <mat-spinner diameter="24"></mat-spinner>
    </div>
  </div>
</ng-container>

<ng-template #multiSelectT>
  <div
    class="list-view-container"
    style="
      padding-top: 10px;
      padding-bottom: 10px;
      min-width: 350px;
      position: relative;
    "
  >
    <div style="height: 350px">
      <input
        #textbox
        class="e-input multiselect-filter-input"
        type="text"
        [placeholder]="loading ? 'Searching...' : 'Type at least 3 characters to search'"
        (keyup)="onFilterKeyUp($event)"
      />
      <div class="list-loading-overlay fade-transition" [class.visible]="loading" aria-live="polite">
        <mat-spinner diameter="48"></mat-spinner>
        <span class="list-loading-text">Searching...</span>
      </div>
      <ejs-listview
        class="fade-transition multiselect-list"
        [class.visible]="!loading"
        style="max-width: 350px; min-width: 350px"
        id="multiselectelement"
        #multiselectelement
        height="300px"
        [showHeader]="false"
        [enableVirtualization]="true"
        [dataSource]="filteredUserList"
        [fields]="listViewFields"
        [showCheckBox]="true"
        [allowFiltering]="true"
        (select)="onSelect($event)"
        [allowMultiSelection]="true"
      >
      </ejs-listview>
    </div>
  </div>
</ng-template>

